import { type AnyAction, type MiddlewareAPI, type Dispatch } from 'redux';

export const actionBlockerMiddleware =
  ({ getState }: MiddlewareAPI) =>
  (next: Dispatch) =>
  (action: AnyAction): void => {
    next(action);
  };
